<template>
  <v-card flat rounded="lg" width="100%" class="grey lighten-3 image-input">
    <v-responsive :aspect-ratio="1">
      <input 
        type="file" 
        accept="image/*" 
        @change="onFileChange($event.target.files[0])"
        ref="file-input"
      >
      <v-img
        :src="base64"
        width="100%"
        height="100%"
        dark
      >
        <v-card-title>
          <v-btn
            dark
            icon
            class="darked mr-3"
            @click="emitFileInput"
            :loading="loading"
          >
            <v-icon>mdi-cloud-upload</v-icon>
          </v-btn>
          <v-btn
            dark
            icon
            class="darked"
            @click="purge"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
      </v-img>
    </v-responsive>
  </v-card>
</template>

<script>
import { TempFileAPI } from '@/api';
export default {
  data() {
    return {
      base64: '',
      loading: false,
    }
  },
  props: {
    image: {
      type: [ String, File, null ],
      default: null
    }
  },
  methods: {
    purge() {
      this.$emit('file-upload', null);
      this.base64 = null;
    },
    emitFileInput() {
      this.$refs['file-input'].click();
    },
    onFileChange(file){
      this.fileToBase64(file);
      this.loading = true;
      TempFileAPI.upload(file).then(res => {
        this.loading = false;
        this.$emit('file-upload', res.data._id);
      })
    },
    fileToBase64(file){
      let reader = new FileReader();
      reader.addEventListener('load', () => {
        this.base64 = reader.result;
      }, false);
      reader.readAsDataURL(file);
    },
    processInput(value) {
      if(value instanceof File){
        this.fileToBase64(value);
      } else {
        this.base64 = value;
      }
    }
  },
  created() {
    this.processInput(this.image);
  },
  watch: {
    'image': function (to) {
      this.base64 = '';
      this.processInput(to);
    }
  },
  computed: {

  },
}
</script>

<style lang="scss" scoped>

.image-input {

  position: relative;
  overflow: hidden;

  input[type="file"] {
    display: none;
  }

  .darked {
    background: rgba($color: #000000, $alpha: 0.3);
  }
}
</style>
